<script setup lang="ts">
import { useSalesQueueSlotsApi } from '../api/slots-management/sales-queue.hook'
import SalesQueueSlotsSection from './slots-management/SalesQueueSlotsSection.vue'

defineOptions({
  name: 'DemosSlotsManagementSalesQueuePage',
})

onMounted(() => {
  void useSalesQueueSlotsApi()
})
</script>

<template>
  <SalesQueueSlotsSection />
</template>
